import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LeModalService} from "common-shared";
import {GraphOptionsComponent} from "../graph-options/graph-options.component";

@Component({
  selector: 'app-graph-button',
  templateUrl: './graph-button.component.html',
  styles: []
})
export class GraphButtonComponent implements OnInit {
  @Input() title: string;
  @Input() showOptions: boolean = true;
  @Input() showGraphBuilderButton: boolean = false;
  @Output() showGraph = new EventEmitter();
  @Output() showGraphBuilder = new EventEmitter();

  constructor(protected modalService: LeModalService) {
  }

  ngOnInit(): void {
  }

  shopGraphOptions() {
    this.modalService.show(GraphOptionsComponent, {});
  }
}
